import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
	addGroupWiseLoanProposalFailure,
	addGroupWiseLoanProposalResponseChanged,
	addGroupWiseLoanProposalSuccess,
	getSubGroupListFailure,
	getSubGroupListResponseChanged,
	getSubGroupListSuccess,
	updateGroupWiseLoanProposalFailure,
	updateGroupWiseLoanProposalResponseChanged,
	updateGroupWiseLoanProposalSuccess,
} from './group-wise-loan-proposal.action';
import GroupWiseLoanProposalActionTypes from './group-wise-loan-proposal.types';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { createNewGroupWiseLoan, updateGroupWiseLoan } from './group-wise-loan-proposal.service';

/** *********************  START ADD GROUP LOAN PROPOSAL   ******************** */
export function* createNewLoanProposal({ payload }: any) {
	try {
		const key = 'AddLoanIndexDataKey';
		const jsonData = {
			AreaID: payload.AreaID,
			BranchID: payload.BranchID,
			LoanProposalDate: payload.LoanProposalDate,
			TotalLoanAmount: payload.TotalLoanAmount,
			LoanStartDate: payload.LoanStartDate,
			OldLoanStartDate: payload.OldLoanStartDate,
			LoanEndDate: payload.LoanEndDate,
			MeetUpLocation: payload.MeetUpLocation,
			MemberMeetupLat: payload.MemberMeetupLat,
			MemberMeetupLong: payload.MemberMeetupLong,
			MeetUpTime: payload.MeetUpTime,
			GroupID: payload.GroupID,
			GroupProductID: payload.GroupProductID,
			GroupMemberLeadID: payload.GroupMemberLeadID,
			GroupOfficerID: payload.GroupOfficerID,
			CreatedUser: payload.userID,
			LoanIndexType: payload.LoanIndexType,
			LoanIndexID: payload.LoanIndexID,
			LoanIndexGroupMember: payload.LoanIndexGroupMember,
			ProductInvestorDetails: payload.ProductInvestorDetails,
			FunderName: payload.FunderName,
			DatabaseName: payload.databaseName,
			UserName: payload.userName,
			UserAccessBranchID: payload.userAccessBranchID,
			CompanyID: payload.companyID,
			CreatedBy: payload.userID,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(createNewGroupWiseLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addGroupWiseLoanProposalFailure(responseData.data));
		} else {
			yield put(addGroupWiseLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addGroupWiseLoanProposalFailure(error));
	}
}

export function* resetAddGroupWiseLoanProposalResponse() {
	yield put(addGroupWiseLoanProposalResponseChanged());
}

export function* callcreateNewLoanProposal() {
	yield takeLatest(
		GroupWiseLoanProposalActionTypes.ADD_GROUP_WISE_LOAN_PROPOSAL_START,
		createNewLoanProposal,
	);
}

export function* onCreateGroupWiseLoanProposalResponseReset() {
	yield takeLatest(
		GroupWiseLoanProposalActionTypes.ADD_GROUP_WISE_LOAN_PROPOSAL_RESPONSE_RESET,
		resetAddGroupWiseLoanProposalResponse,
	);
}
/** *********************  END ADD GROUP WISE LOAN PROPOSAL  ******************** */

/** *********************  START UPDATE CENTER WISE LOAN PROPOSAL   ******************** */
export function* updateGroupWiseLoanProposal({ payload }: any) {
	try {
		const key = 'UpdateALoanIndexKey';
		const jsonData = {
			AreaID: payload.AreaID,
			BranchID: payload.BranchID,
			LoanProposalDate: payload.LoanProposalDate,
			TotalLoanAmount: payload.TotalLoanAmount,
			LoanStartDate: payload.LoanStartDate,
			OldLoanStartDate: payload.OldLoanStartDate,
			LoanEndDate: payload.LoanEndDate,
			MeetUpLocation: payload.MeetUpLocation,
			MemberMeetupLat: payload.MemberMeetupLat,
			MemberMeetupLong: payload.MemberMeetupLong,
			MeetUpTime: payload.MeetUpTime,
			GroupID: payload.GroupID,
			GroupProductID: payload.GroupProductID,
			GroupMemberLeadID: payload.GroupMemberLeadID,
			GroupOfficerID: payload.GroupOfficerID,
			CreatedUser: payload.userID,
			LoanIndexType: payload.LoanIndexType,
			LoanIndexID: payload.LoanIndexID,
			LoanIndexGroupMember: payload.LoanIndexGroupMember,
			ProductInvestorDetails: payload.ProductInvestorDetails,
			FunderName: payload.FunderName,
			DatabaseName: payload.databaseName,
			UserName: payload.userName,
			UserAccessBranchID: payload.userAccessBranchID,
			CompanyID: payload.companyID,
			CreatedBy: payload.userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateGroupWiseLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateGroupWiseLoanProposalFailure(responseData.data));
		} else {
			yield put(updateGroupWiseLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateGroupWiseLoanProposalFailure(error));
	}
}

export function* resetUpdateGroupWiseLoanProposalResponse() {
	yield put(updateGroupWiseLoanProposalResponseChanged());
}

export function* onUpdateLoanProposal() {
	yield takeLatest(
		GroupWiseLoanProposalActionTypes.UPDATE_GROUP_WISE_LOAN_PROPOSAL_START,
		updateGroupWiseLoanProposal,
	);
}

export function* onUpdateGroupWiseLoanProposalResponseReset() {
	yield takeLatest(
		GroupWiseLoanProposalActionTypes.UPDATE_GROUP_WISE_LOAN_PROPOSAL_RESPONSE_RESET,
		resetUpdateGroupWiseLoanProposalResponse,
	);
}
/** *********************  END UPDATE GROUP WISE LOAN PROPOSAL  ******************** */

export function* sunGroupListGet({ payload }: any) {
	try {
		const key = 'GetSubGroupDetailsTokenKey';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			ParentGroupID: payload.ParentGroupID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getSubGroupList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getSubGroupListFailure(responseData.data));
		} else {
			yield put(getSubGroupListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getSubGroupListFailure(error));
	}
}

export function* resetGetSubGroupListDetailsResponse() {
	yield put(getSubGroupListResponseChanged());
}

export function* onGetSubGroupListDetails() {
	yield takeLatest(GroupWiseLoanProposalActionTypes.GET_SUBGROUP_LIST_START, sunGroupListGet);
}

export function* onGetSubGroupListDetailsResponseReset() {
	yield takeLatest(
		GroupWiseLoanProposalActionTypes.GET_SUBGROUP_LIST_RESPONSE_RESET,
		resetGetSubGroupListDetailsResponse,
	);
}

export function* groupWiseLoanProposalSaga() {
	yield all([
		call(onCreateGroupWiseLoanProposalResponseReset),
		call(callcreateNewLoanProposal),
		call(onUpdateLoanProposal),
		call(onUpdateGroupWiseLoanProposalResponseReset),
		call(onGetSubGroupListDetails),
		call(onGetSubGroupListDetailsResponseReset),
	]);
}
